import React from 'react'
import { useApp } from '../../context/AppContext'
import { Icon } from '../../shared'
import { Card, Btn, Badge, Progress } from '../../shared/components'

// Satu baris per program: peserta, berapa yang sudah tersertifikasi, dan
// berapa yang layak tapi belum klaim. `perProgram` datang dari
// /reports/analytics/summary, jadi tidak ada panggilan tambahan.
export function ProgramsOverviewCard({ programs, perProgram }) {
  const { lang, navigate, setCurrentProgramId, user } = useApp()
  const stats = new Map((perProgram || []).map((p) => [p.id, p]))

  return (
    <Card
      title={lang === 'id' ? 'Program' : 'Programs'}
      action={
        <Btn variant="ghost" size="sm" onClick={() => navigate('training')}>
          {lang === 'id' ? 'Kelola' : 'Manage'}
        </Btn>
      }
      noPad
    >
      {programs.length === 0 ? (
        <div className="col" style={{ alignItems: 'center', padding: '28px 18px', gap: 8 }}>
          <Icon name="layers" size={22} color="var(--text-4)" />
          <div className="tiny muted">{lang === 'id' ? 'Belum ada program' : 'No programs yet'}</div>
          {/* Program hanya bisa dibuat admin lembaga; yang lain tidak ditawari tombolnya. */}
          {user?.role === 'SUPER_ADMIN' && (
            <Btn variant="primary" size="sm" icon={<Icon name="plus" size={12} />} onClick={() => navigate('programs-manage')}>
              {lang === 'id' ? 'Program baru' : 'New program'}
            </Btn>
          )}
        </div>
      ) : (
        <div className="col" style={{ padding: '4px 18px 10px' }}>
          {programs.map((p) => {
            const s = stats.get(p.id) || { participants: 0, certified: 0, certPending: 0 }
            return (
              <div
                key={p.id}
                role="button"
                tabIndex={0}
                onClick={() => { setCurrentProgramId(p.id); navigate('progress') }}
                onKeyDown={(e) => { if (e.key === 'Enter') { setCurrentProgramId(p.id); navigate('progress') } }}
                style={{ padding: '12px 0', borderBottom: '1px solid var(--border-subtle)', cursor: 'pointer' }}
              >
                <div className="row between" style={{ alignItems: 'center', gap: 8 }}>
                  <div className="row gap-2" style={{ alignItems: 'center', minWidth: 0 }}>
                    <span style={{ width: 8, height: 8, borderRadius: '50%', background: p.color_theme || 'var(--program-color)', flexShrink: 0 }} />
                    <span className="small text-truncate" style={{ fontWeight: 500 }}>{p.name}</span>
                  </div>
                  <div className="row gap-2" style={{ alignItems: 'center', flexShrink: 0 }}>
                    {s.certPending > 0 && (
                      <Badge tone="warning">{s.certPending} {lang === 'id' ? 'menunggu klaim' : 'to claim'}</Badge>
                    )}
                    <span className="tiny muted tnum">
                      {s.participants} {lang === 'id' ? 'peserta' : 'participants'}
                    </span>
                  </div>
                </div>
                <Progress
                  value={s.certified}
                  max={s.participants || 1}
                  color={p.color_theme}
                  style={{ marginTop: 8 }}
                />
                <div className="tiny muted" style={{ marginTop: 4 }}>
                  {s.participants === 0
                    ? (lang === 'id' ? 'Belum ada peserta' : 'No participants yet')
                    : `${s.certified}/${s.participants} ${lang === 'id' ? 'tersertifikasi' : 'certified'}`}
                </div>
              </div>
            )
          })}
        </div>
      )}
    </Card>
  )
}
